import { render } from "./CollegeTable.vue?vue&type=template&id=c20f11b8&scoped=true"
import script from "./CollegeTable.vue?vue&type=script&lang=js"
export * from "./CollegeTable.vue?vue&type=script&lang=js"

import "./CollegeTable.vue?vue&type=style&index=0&id=c20f11b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c20f11b8"]])

export default __exports__